import React, { useState, useEffect, useContext } from "react";
import {
  Flex,
  Text,
  useDisclosure,
  VStack,
  Heading,
  CardBody,
  Card,
  FormLabel,
  HStack,
} from "@chakra-ui/react";

import AddMyVoice from "../../Modals/AddMyVoice";
import { fetchController } from "../../../utils/FetchController/fetchController";
import WhatsAppModal from "../../Modals/WhatsApp";
import VoiceTimestampModal from "../../Modals/VoiceTimestampModal";
import { SettingContext } from "../Reducer/SettingProvider";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import AuthContext from "../../Auth/AuthContext";
import { getHostDomain } from "../../../utils/utils";

const Profile = () => {
  const baseUrl = getHostDomain();
  const [isMyVoiceRecorded, setIsMyVoiceRecorded] = useState(false);
  const [voiceData, setVoiceData] = useState([]);
  const { state: activatedPlan } = useContext(SettingContext);
  const {
    isOpen: isAddMyVoiceModalOpen,
    onOpen: onAddMyVoiceModalOpen,
    onClose: onAddMyVoiceModalClose,
  } = useDisclosure();
  const {
    isOpen: isOpenWhatsApp,
    onOpen: onOpenWhatsapp,
    onClose: onCloseWhatsapp,
  } = useDisclosure();
  const {
    isOpen: isVoiceTimeStampModalOpen,
    onOpen: onVoiceTimeStampModalOpen,
    onClose: onVoiceTimeStampModalClose,
  } = useDisclosure();

  const { authUser } = useContext(AuthContext);

  const [image, setImage] = useState(null);

  useEffect(() => {
    if (authUser?.picture) {
      setImage(authUser.picture);
    }
  }, [authUser.picture]);

  const loadOwnVoice = async () => {
    const endpoint = `/api/v1/voice/list`;
    const urlHit = baseUrl + endpoint;
    const getData = await fetchController(urlHit, "GET");

    const modifiedData = getData?.data?.items?.map((val, index) => {
      return {
        value: val.id,
        label: val.name,
      };
    });
    setVoiceData(getData?.data?.items);
    setIsMyVoiceRecorded(modifiedData?.length > 0 ? true : false);
  };

  useEffect(() => {
    if (
      activatedPlan.plan_lookup_key !== "insightoai_free" ||
      activatedPlan.plan_lookup_key !== "insightoai_gold"
    ) {
      loadOwnVoice();
    }
  }, []);
  const agency = useContext(AgencyContext);
  const { buttonColorScheme, textColor } = agency;
  return (
    <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
      <Flex gap={2} w={"100%"} alignItems="center" py={2}>
        <Heading color={textColor} fontSize="xl">
          Profile
        </Heading>
      </Flex>

      <Card maxW={"300px"} variant={"elevated"}>
        <CardBody>
          <Flex flexDirection="column" gap={2}>
            <HStack spacing={2} alignItems={"center"}>
              <FormLabel m={0}>Name: </FormLabel>
              <Text fontSize="sm" color="gray.500">
                {authUser?.first_name ||
                  authUser?.given_name ||
                  "Not available"}
              </Text>
            </HStack>

            <HStack spacing={2} alignItems={"center"}>
              <FormLabel m={0}>Email: </FormLabel>
              <Text fontSize="sm" color="gray.500">
                {authUser?.email}
              </Text>
            </HStack>
          </Flex>
        </CardBody>
      </Card>
      <WhatsAppModal
        isOpen={isOpenWhatsApp}
        onOpen={onOpenWhatsapp}
        onClose={onCloseWhatsapp}
        loadUserWhatsAppDetails={[]}
      />
      {isAddMyVoiceModalOpen && (
        <AddMyVoice
          isAddMyVoiceModalOpen={isAddMyVoiceModalOpen}
          onAddMyVoiceModalClose={onAddMyVoiceModalClose}
          isMyVoiceRecorded={isMyVoiceRecorded}
          loadOwnVoice={loadOwnVoice}
          isUpdatingVoice={isMyVoiceRecorded}
          buttonColorScheme={buttonColorScheme}
        />
      )}
      <VoiceTimestampModal
        isVoiceTimeStampModalOpen={isVoiceTimeStampModalOpen}
        onVoiceTimeStampModalOpen={onVoiceTimeStampModalOpen}
        onVoiceTimeStampModalClose={onVoiceTimeStampModalClose}
        onAddMyVoiceModalOpen={onAddMyVoiceModalOpen}
        voiceData={voiceData}
        buttonColorScheme={buttonColorScheme}
      />
    </Flex>
  );
};

export default Profile;
